import { render, staticRenderFns } from "./NotificationsSettingsFormJobs.vue?vue&type=template&id=1feaec04"
import script from "./NotificationsSettingsFormJobs.vue?vue&type=script&lang=js"
export * from "./NotificationsSettingsFormJobs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports